import React, {useEffect} from 'react';
import { Grid, Typography, Button, makeStyles} from '@material-ui/core';
import CleaningCard from '../components/CleaningCard';
// import CleaningCard from './CleaningCard_FBSpark';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCleaningPlaces } from '../reducks/cleaningPlace/operations';
import { getCleaningList } from '../reducks/cleaningPlace/selectors';
import { push } from 'connected-react-router';

/**
 * Styleの定義
 */
 const useStyles = makeStyles((theme) => ({
    button: {
        color: theme.palette.text.secondary,
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
}));
const CleanPlaces = () => {

    // Reduxとの連携
    const dispatch = useDispatch();
    const selector = useSelector(state => state);
    const cleaningList = getCleaningList(selector);
    useEffect(() => {
        dispatch(fetchCleaningPlaces())
    }, [])
    const classes = useStyles();

    return (
        <div>
            <Grid container spacing={2}>
                {cleaningList.length > 0 && 
                    <Grid item xs={6}>
                        <CleaningCard 
                            key="subject0" content={cleaningList[0].content} 
                            difficulity={cleaningList[0].difficulity} imagePath={cleaningList[0].imagePath}
                            subject={cleaningList[0].subject} />
                    </Grid>
                }
                {cleaningList.length > 0 && 
                    <Grid item xs={6}>
                        <CleaningCard 
                            key="subject1" content={cleaningList[1].content} 
                            difficulity={cleaningList[1].difficulity} imagePath={cleaningList[1].imagePath} 
                            subject={cleaningList[1].subject} />
                    </Grid>
                }
            </Grid>
        </div>
    )
}

export default CleanPlaces;